import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import ResearchNav from '@/components/admin/research/ResearchNav'
import ResearchOrganizationForm from '@/components/admin/research/ResearchOrganizationForm'

type Props = {
  causes: string[]
}

export default function ResearchOrganizationNew({ causes }: Props) {
  return (
    <>
      <Head title="Research - New Organization" />
      <div>
        <h1 className="text-3xl font-semibold tracking-tight font-serif">Research Database</h1>
        <div className="mt-4">
          <ResearchNav />
        </div>
        <h2 className="mb-6 text-2xl font-semibold tracking-tight">New Organization</h2>
        <div className="max-w-3xl">
          <ResearchOrganizationForm causes={causes} />
        </div>
      </div>
    </>
  )
}

ResearchOrganizationNew.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
